module.exports = __webpack_public_path__ + "img/index-partners-banner-5.8c85cd17.jpg";